var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUkFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2961_27997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2H16V14H0V2Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875 2L7.975 6.525L14.05 2H16V3.55L10 8.025L16 12.475V14H14L8 9.525L2.025 14H0V12.5L5.975 8.05L0 3.6V2H1.875Z",
    fill: "#5C5C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6 9.025L16 13V14L9.225 9.025H10.6ZM6 9.525L6.15 10.4L1.35 14H0L6 9.525ZM16 2V2.075L9.775 6.775L9.825 5.675L14.75 2H16ZM0 2L5.975 6.4H4.475L0 3.05V2Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.025 2V14H10.025V2H6.025ZM0 6V10H16V6H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.825V9.225H16V6.825H0ZM6.825 2V14H9.225V2H6.825Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2961_27997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white",
    transform: "translate(0 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/uk-flag.7974aceaf7bffed4da4e719391a06590.svg";
export { ForwardRef as ReactComponent };